import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from "@angular/core";

@Component({
    selector: "fhm-venue-deployment-status-select-control",
    templateUrl: "./venue-deployment-status-select-control.component.html",
    standalone: false
})
export class VenueDeploymentStatusSelectControlComponent implements OnChanges {
    @Output() public removed: EventEmitter<any> = new EventEmitter();

    @Output() public valueChange: EventEmitter<string> = new EventEmitter();

    @Input() public value: string;

    public selectedValue: any;

    public options: any[] = [
        {label: "PENDING", value: "PENDING"},
        {label: "READY", value: "READY"},
        {label: "DEPLOYED", value: "DEPLOYED"},
        {label: "CHURNED", value: "CHURNED"}
    ];

    public updateStateOnValueChange(): void {
        if (this.selectedValue) {
            this.valueChange.emit(this.selectedValue["value"]);
        } else {
            this.valueChange.emit();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.selectedValue = undefined;
        this.options.forEach(d => {
            if (d.value === this.value) {
                this.selectedValue = d;
            }
        });
    }

}
